import React, { useState, useEffect, Fragment, useMemo, } from "react";
import ReactDOM from 'react-dom'
import { Route, Redirect } from 'react-router-dom'
import io from "socket.io-client";

import { Header, Segment, Grid, Modal, Divider, List } from 'semantic-ui-react'
import { connect } from 'react-redux'
import DownloadAppNotification from '../../DownloadAppNotification'
import AssistanceModal from '../ClientSite/AssistanceModal'
import ClientTopBar from '../ClientSite/ClientTopBar'
import ClientBottomBar from '../ClientSite/ClientBottomBar'
import LoginModal from '../ClientSite/LoginModal'

import {getInternalCart} from '../../store/actions/cart'
import { getSysCompanyInfo, } from '../../store/actions/access'
import {loadTableInfo} from '../../store/actions/clients'
import {fetchTimers} from '../../store/actions/timer'
import getUrlParams from '../../utils/getUrlParams'
import translations from '../../utils/translations';

const pagesToShowBottomBar = ["/client/company_qr_scanning", "/client/orders"]
const pagesHideTopBar = ["/client/download_ruf", "/client/search"]

const fullURL = new URL(`${process.env.REACT_APP_ENDPOINT}`)

let socket

const NewPublicClientRoute = (props) => {
	const {
		getInternalCart,
		getSysCompanyInfo,
		loadTableInfo,
		setIsQrRead,
		fetchTimers,
		dispatch,

		client,
		lang,
		showLoginModal,
		generalParameters,
		sysCompanyId,
		foodStallId,
		company,
		currentTranslations,
		
		component: Component,
		...rest
	} = props

	const userAgent = navigator.userAgent

	const urlParams = useMemo(() => getUrlParams(document.URL), [document.URL])

	// this effect checks if there's a tableCode or companyCode in the url and if there is, it loads the company information and the table information if there's a tableCode, if the information is loaded successfully it sets the isQrRead state to true, if there's an error it shows an alert with the message "enter a valid code"
	useEffect(async () => {
		if (!sysCompanyId && !foodStallId) {
			let company = null;
			const handleBarCodeRead = async () => {
				try {
					if (urlParams.tableCode) {
						if (!/^\d+[mM]+\d+$/.test(urlParams.tableCode)) {
							throw new Error('Invalid code')
						}
						const [sys_company_id, table_id] = urlParams.tableCode
							?.toUpperCase()
							?.split("M");

						company = await props.getSysCompanyInfo(sys_company_id);

						const station = await props.loadTableInfo({
							sysCompanyId: sys_company_id,
							tableId: table_id,
						});

						if (!station?.id) {
							throw new Error('There was an error loading the station')
						}

						// if (urlParams?.qrScaned) {
							setIsQrRead()
						// }

					} else if (urlParams.companyCode) {

						const sys_company_id = urlParams.companyCode?.slice(2);

						if (!(!isNaN(sys_company_id) && sys_company_id > 0)) {
							throw new Error('')
						}

						company = await props.getSysCompanyInfo(sys_company_id);

						if (urlParams?.qrScaned) {
							setIsQrRead()
						}

					} else {
						// throw new Error('')
					}

				} catch (e) {
					console.error('ERROR:', e.message);
					alert(currentTranslations?.enterValidCode);
				}
			};

			await handleBarCodeRead();

			// this checks the parameters of the company and redirects to the corresponding page depending on the parameters, if the scan_qr_web parameter is false it redirects to the download ruf page, if it's a food center with child companies it redirects to the stalls page, if not it redirects to the products page
			if (!window.location.pathname?.includes('/client/download_ruf')) {
				const handleRedirection = async () => {
					try {
						// if the company has the scan_qr_web parameter set to false, redirect to the download ruf page, if not check if it's a food center with child companies and redirect to the stalls page, if not redirect to the products page
						if (
							company?.GeneralParameters?.scan_qr_web === false
							&& !window.location.pathname?.includes('/client/download_ruf')
						) {
							window.location.href = `${fullURL}client/download_ruf${Object.keys(urlParams)?.length >= 1 ? '?' + document.URL.slice(document.URL.indexOf('?') + 1) : ''}`
						}
						else if (
							company?.ChildCompanies?.length >= 1
							&& company?.attention_type == 'food_center'
							&& !window.location?.href?.includes('client/stalls')
							&& !window.location?.href?.includes('client/download_ruf')
						) {
							window.location.href = `${fullURL}client/stalls?${urlParams?.companyCode ? `companyCode=${urlParams.companyCode}` : urlParams?.tableCode ? `tableCode=${urlParams.tableCode}` : ''}`
						}
						else if (
							company
							&& !(company?.ChildCompanies?.length >= 1)
							&& !(company?.attention_type == 'food_center')
							&& !window.location?.href?.includes('client/products')
							&& !window.location?.href?.includes('client/download_ruf')
						) {
							window.location.href = `${fullURL}client/products?${urlParams?.companyCode ? `companyCode=${urlParams.companyCode}` : urlParams?.tableCode ? `tableCode=${urlParams.tableCode}` : ''}`
						}
					} catch (e) {
						console.error('ERROR:', e.message);
					}
				};

				handleRedirection();
			}
		}
	}, [urlParams?.tableCode, urlParams?.companyCode, sysCompanyId, foodStallId]);

	// this effect runs when the company information is loaded and the user is on the download ruf page, it checks the parameters of the company and if the scan_qr_web parameter is false it tries to open the app using the custom protocol restec:// if the app is not installed it redirects to the app store, if it's an ios device it redirects to the apple store and if it's an android device it redirects to the google play store, it also checks if there's a tableCode or companyCode in the url and if there is it adds it to the custom protocol url, for example restec://?companyCode=12345, restec://?tableCode=12345, if there's no parameter it just tries to open the app with restec://, this effect also has a fallback delay of 6 seconds for the company code and 4 seconds for the table code, this means that if after 6 seconds for the company code or 4 seconds for the table code the app is not opened it will redirect to the app store, it also listens for the visibility change event to clear the fallback timeout if the app is opened successfully
	useEffect(() => {
		if(generalParameters?.scan_qr_web === false && window.location.pathname?.includes('/client/download_ruf')){	
 			if (urlParams?.companyCode) {
				const fallbackDelay = 6000;
				const code = urlParams.companyCode;
				const companyCode = encodeURIComponent(code.split("sp")[1]);

				const appUrl = `restec://?companyCode=${urlParams?.companyCode}`;
				if (userAgent.includes('iPhone')) {
					// Para iOS: redirigir a la app y luego a la App Store si no se abre
					let fallbackTimeout = setTimeout(() => {
						window.location.href = 'https://apps.apple.com/mx/app/ruf-asistencia-al-instante/id6463335518';
					}, fallbackDelay);
	
					window.location.href = appUrl;
	
					const handleVisibilityChange = () => {
						if (document.hidden) {
							clearTimeout(fallbackTimeout);
						}
					};
	
					document.addEventListener('visibilitychange', handleVisibilityChange);
	
				} else if (userAgent.includes('Android')) {
					let fallbackTimeout = setTimeout(() => {
						window.location.href = 'https://play.google.com/store/apps/details?id=mx.restec';
					}, fallbackDelay);
	
					window.location.href = appUrl;
	
					const handleVisibilityChange = () => {
						if (document.hidden) {
							clearTimeout(fallbackTimeout);
						}
					};
	
					document.addEventListener('visibilitychange', handleVisibilityChange);
	
				}
			}
	
			if (urlParams?.tableCode) {
				const fallbackDelay = 4000;
				const tableCode = urlParams.tableCode;
	
				const appUrl = `restec://?tableCode=${urlParams?.tableCode}`;
				if (userAgent.includes('iPhone')) {
					// Para iOS: redirigir a la app y luego a la App Store si no se abre
					let fallbackTimeout = setTimeout(() => {
						window.location.href = 'https://apps.apple.com/mx/app/ruf-asistencia-al-instante/id6463335518';
					}, fallbackDelay);
	
					window.location.href = appUrl;
	
					const handleVisibilityChange = () => {
						if (document.hidden) {
							clearTimeout(fallbackTimeout);
						}
					};
	
					document.addEventListener('visibilitychange', handleVisibilityChange);
	
				} else if (userAgent.includes('Android')) {
					let fallbackTimeout = setTimeout(() => {
						window.location.href = 'https://play.google.com/store/apps/details?id=mx.restec';
					}, fallbackDelay);
	
					window.location.href = appUrl;
	
					const handleVisibilityChange = () => {
						if (document.hidden) {
							clearTimeout(fallbackTimeout);
						}
					};
	
					document.addEventListener('visibilitychange', handleVisibilityChange);
				}
			}
		}
	}, [generalParameters])

	useEffect(() => {
      getInternalCart();
    }, []);

	useEffect(() => {
		if (client?.id) {
			fetchTimers(client.id);
		}
	}, [client]);

	useEffect(() => {
		if (!!client) {
			const url = `${process.env.REACT_APP_API_ENDPOINT}`;

			const socket = io(url, {
				path: "/client_notifications-socket",
				transports: ["websocket"],
				query: {
					client_id: client.id,
					component: "navBar",
				},
			});

			socket.on("connect", () => {
				console.log(`clint_id: ${client.id} conectado, path: /client_notifications-socket`);
			});

			socket.on("unread_client_notifications", (notifications) => {
				dispatch({
					type: "LOAD_CLIENT_NOTIFICATIONS",
					response: notifications,
				});
			});

			socket.on("upcoming_reservations", (upcomingReservations) => {
				dispatch({
					type: "SET_UPCOMING_RESERVATIONS",
					response: upcomingReservations.quantity,
				});
			});

			socket.on("new_client_notification", (notification) => {
				dispatch({
					type: "ADD_CLIENT_NOTIFICATION",
					response: notification,
				});
			});

			// socket.on("new_offer", (offer) => {
			// 	dispatch({
			// 		type: "ADD_OFFER",
			// 		response: offer,
			// 	});
			// });

			// socket.on("new_announcement", (announcement) => {
			// 	dispatch({
			// 		type: "ADD_ANNOUNCEMENT",
			// 		response: announcement,
			// 	});
			// });

			// socket.on("new_timer", (timer) => {
			// 	dispatch({
			// 		type: "CREATE_TIMER_SUCCESS",
			// 		payload: timer,
			// 	});
			// });

			// socket.on("update_notification", (reservation) => {
			// 	if (reservation?.id) {
			// 		dispatch({
			// 			type: "UPDATE_RESERVATION",
			// 			response: reservation,
			// 		});
			// 	}
			// });

			socket.on("disconnect", () => {
				console.log(
					`clint_id: ${client.id} desconectado, path: /client_notifications-socket`
				);
			});

			return () => {
				socket.disconnect();
			};
		}
	}, []);

	return (
		<>
			<Route
				{...rest}
				render={(routeProps) => (
					<Fragment>
						<div 
							style={{
								position: 'relative', 
								overflow: 'hidden', 
								height: (userAgent.includes('iPhone') || userAgent.includes('Android'))?'90vh':'100vh', 
								display: 'flex', 
								flexDirection: 'column',
							}}
						>
							{!pagesHideTopBar?.includes(routeProps.location.pathname) && <ClientTopBar {...routeProps} {...props} />}

							<div 
								style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									flex: 1,
									backgroundColor: 'rgba(255, 255, 255, 0.6)',
									overflowY: 'hidden',
									width: '100%',
								}}
							>
								<Component {...routeProps} />
							</div>

							{pagesToShowBottomBar?.includes(routeProps.location.pathname) && <ClientBottomBar {...routeProps}/>}
						</div>
					</Fragment>
				)}
			/>

			{(!client && showLoginModal) && <LoginModal />}
			
			<AssistanceModal />

			<DownloadAppNotification />
		</>
	);
};

const mapDispatchToProps = (dispatch) => ({
	getInternalCart: () => dispatch(getInternalCart()),
	getSysCompanyInfo: (sys_company_id) => dispatch(getSysCompanyInfo(sys_company_id)),
	loadTableInfo: (tableInfo) => dispatch(loadTableInfo(tableInfo)),
	setIsQrRead: () => dispatch({ type: 'SET_IS_QR_READ' }),
	fetchTimers: (clientId) => dispatch(fetchTimers(clientId)),
	dispatch: (data) => dispatch(data),
})

const mapStateToProps = (state) => ({
	client: state.app.client,
	lang: state.app.lang ?? 'en',
	showLoginModal: state.access?.showLoginModal,
	generalParameters: state.access.generalParameters,
	sysCompanyId: state.access.sysCompanyId,
	foodStallId: state.access.foodStallId,
	company: state.access?.company,
	currentTranslations: translations[state?.app?.lang ?? 'es'],
});

export default connect(mapStateToProps, mapDispatchToProps)(NewPublicClientRoute);
